import { app } from "router/routes"
import { ReactComponent as HomeIcon } from 'assets/icons/Home.svg';
import { ReactComponent as TestTakersIcon } from 'assets/icons/Testtakers.svg';
import { ReactComponent as ActiveAssessmentsIcon } from 'assets/icons/ActiveAssessments.svg';
import { ReactComponent as AssessmentsIcon } from 'assets/icons/Assessments.svg';
import { ReactComponent as WhatNewsIcon } from 'assets/icons/WhatNews.svg';
import { useMemo } from "react";

const useGeneralItems = () => {

    const generalItems = useMemo(
        () => [
            {
                title: "סקירת המצב העכשוי שלך במערכת",
                to: app.dashboard,
                button: {
                    label: "בית",
                    icon: HomeIcon
                },
                type: "home",
            },
            {
                title: "רשימת התלמידים עם הוספת ועדכון פרטי תלמיד",
                to: app.testTakers,
                button: {
                    label: "תלמידים",
                    icon: TestTakersIcon
                },
                type: "students"
            },
            {
                title: "ניהול ביצוע האבחונים של התלמידים שלך לסמסטר הנוכחי",
                to: app.allAssessments,
                button: {
                    label: "אבחונים פעילים",
                    icon: ActiveAssessmentsIcon
                },
                type: "assessments"
            },
            {
                title: "תוצאות האבחונים במבט כיתתי, אישי והמלצות לדרכי פעולה",
                to: app.assessments,
                button: {
                    label: "דוחות",
                    icon: AssessmentsIcon
                },
                type: "reports"
            },
            {
                title: "כל מה שחדש אצלנו",
                to: app.newsletters,
                button: {
                    label: "מה חדש?",
                    icon: WhatNewsIcon
                },
            }
        ], []
    )

    return generalItems
}

export default useGeneralItems